/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2026-03-24T09:23:25.940Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/betGliderCreateSessionRequest
export const BetGliderCreateSessionRequestZod = z.object({
    accountId: z.number(),
    eventId: z.string(),
});
export type BetGliderCreateSessionRequestType = z.TypeOf<typeof BetGliderCreateSessionRequestZod>;


// #/components/schemas/betGliderCreateSessionResponseBody
export const BetGliderCreateSessionResponseBodyZod = z.object({
    oneTimeToken: z.string(),
    sessionId: z.string(),
    launchUrl: z.string(),
});
export type BetGliderCreateSessionResponseBodyType = z.TypeOf<typeof BetGliderCreateSessionResponseBodyZod>;


// #/components/schemas/betGliderEventsMappingResponseOk
export const BetGliderEventsMappingResponseOkZod = z.object({
    value: z.unknown(),
});
export type BetGliderEventsMappingResponseOkType = z.TypeOf<typeof BetGliderEventsMappingResponseOkZod>;

